import { useState, useEffect } from 'react';

/**
 * Returns `value` only after it has stayed unchanged for `delay` ms.
 */
function useDebounce<T>(value: T, delay = 200): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => {
      clearTimeout(handle);
    };
  }, [value, delay]);

  return debounced;
}

export default useDebounce;
